export default "__VITE_ASSET__DPnqm3Yc__"